import type { ApiResponseRecord, HistoryEntry } from '@core/entities/History';
import type { HttpMethod } from '@core/entities/ApiRequest';

export interface ApiResponseResponse {
  id: string;
  status_code: number;
  status_text: string | null;
  headers: Record<string, string[]> | null;
  body: string | null;
  cookies: Array<Record<string, unknown>> | null;
  duration_ms: number;
  size_bytes: number;
  created_at: string;
}

export interface HistoryResponse {
  id: string;
  workspace_id: string;
  request_id?: string | null;
  name: string | null;
  method: HttpMethod;
  url: string;
  status_code: number | null;
  duration_ms: number | null;
  response_size_bytes: number | null;
  error_message: string | null;
  executed_at: string;
  user?: { id: string; name: string } | null;
  response?: ApiResponseResponse | null;
  is_favorited: boolean;
  abilities: { delete: boolean };
}

const toApiResponseRecord = (payload: ApiResponseResponse): ApiResponseRecord => ({
  id: payload.id,
  statusCode: payload.status_code,
  statusText: payload.status_text,
  headers: payload.headers,
  body: payload.body,
  cookies: payload.cookies,
  durationMs: payload.duration_ms,
  sizeBytes: payload.size_bytes,
  createdAt: payload.created_at,
});

export const toHistoryEntry = (payload: HistoryResponse): HistoryEntry => ({
  id: payload.id,
  workspaceId: payload.workspace_id,
  requestId: payload.request_id ?? null,
  name: payload.name,
  method: payload.method,
  url: payload.url,
  statusCode: payload.status_code,
  durationMs: payload.duration_ms,
  responseSizeBytes: payload.response_size_bytes,
  errorMessage: payload.error_message,
  executedAt: payload.executed_at,
  user: payload.user ?? null,
  response: payload.response ? toApiResponseRecord(payload.response) : null,
  isFavorited: payload.is_favorited,
  abilities: payload.abilities,
});
